<template>
  <el-card>
    <div class="h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="请输入岗位名称"
          v-model="equipSearchData.postName"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50"
          filterable
          placeholder="请选择风险等级"
          v-model="equipSearchData.riskLevel"
          clearable
        >
          <el-option
            v-for="item in resultList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          class="mr-10px !w-50"
          filterable
          placeholder="请选择关联风险区域"
          multiple
          collapse-tags
          v-model="equipSearchData.jobAssociatedRiskAreas"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >批量删除</el-button
        >
        <el-button
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >导入</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="岗位名称"
          prop="postName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="工作关联风险区域"
          width="180"
          prop="jobAssociatedRiskAreaStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="风险等级" prop="riskLevel" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ resultListMap(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="安全警示标识" prop="warningSigns" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ markListMap(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <staff-harm-form
      v-if="currentComp === 'CREATE' || currentComp === 'UPDATE' || currentComp === 'READ'"
      :FormData="FormData"
      @refreshList="
        checkComp('TABLE')
        getEquipList()
      "
      @cancel="checkComp('TABLE')"
      :formProps="formProps"
    ></staff-harm-form>

    <staff-harm-card
      v-if="currentComp === 'CARD'"
      :FormData="FormData"
      @cancel="checkComp('TABLE')"
      :rowId="rowId"
    ></staff-harm-card>

    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { EmployeesHazardCharacteristicsCardApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import { AreaApi } from '@wiz-api/area-management'
import { wizUploadFile } from '@wiz-core/compts'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import StaffHarmForm from '../../components/ThreeCardForm/StaffHarmForm'
import StaffHarmCard from '../../components/ThreeCardForm/StaffHarmCard'

const areaApi = new AreaApi()
const employeesHazardCharacteristicsCardApi = new EmployeesHazardCharacteristicsCardApi()

export default {
  name: 'staff-harm',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    StaffHarmForm,
    StaffHarmCard,
    wizUploadFile,
  },
  data() {
    return {
      rowId: null,
      currentComp: 'TABLE',
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['zip'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      FormData: {
        postName: '',
        postNum: '',
        jobAssociatedRiskAreaStr: '',
        riskLevel: null,
        warningSigns: null,
        warningSignPicture: '',
        dangerousHarmfulFactors: '',
        riskControlMeasures: '',
        emergencyMeasures: '',
        emergencyTelephone: '',
        competentUnit: '',
        principalChargePerson: '',
        fieldManager: '',
        annex: undefined,
        jobAssociatedRiskAreasIds: [],
        warningSignsIds: [],
      },
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      resultList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      areaList: [],
      markList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        postName: '',
        jobAssociatedRiskAreas: [],
        riskLevel: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.WarningMark'],
      ['markList'],
      this
    )
    this.getEquipList()
    this.getAreaList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    resultListMap() {
      return (val) => {
        return _.filter(this.resultList, (item) => {
          return item.code === val.riskLevel
        })[0]?.displayName
      }
    },
    markListMap() {
      return (val) => {
        const names = []
        _.forEach(this.markList, (item) => {
          if (val.warningSigns.indexOf(item.code) > -1) {
            names.push(item.displayName)
          }
        })
        return names.join(',')
      }
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
          {
            text: '应知卡',
            click: () => {
              return this.handleEvent(val, 'card')
            },
            isShow: this.$hasAccess('card'),
          },
        ]
      }
    },
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await employeesHazardCharacteristicsCardApi.importFromExcelTemplateFile()
      if (!err) {
        this.downLoadExcel('员工危害特性模板', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      // 上传附件
      const [err, res] = await employeesHazardCharacteristicsCardApi.importFromExcelZip_1({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await employeesHazardCharacteristicsCardApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await employeesHazardCharacteristicsCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            this.FormData.jobAssociatedRiskAreasIds = this.FormData.jobAssociatedRiskAreas.split(
              ','
            )
            this.FormData.warningSignsIds = this.FormData.warningSigns.split(',')
            this.initDialog(operation)
          }
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await employeesHazardCharacteristicsCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            this.FormData.jobAssociatedRiskAreasIds = this.FormData.jobAssociatedRiskAreas.split(
              ','
            )
            this.FormData.warningSignsIds = this.FormData.warningSigns.split(',')
            this.initDialog(operation)
          }
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await employeesHazardCharacteristicsCardApi.deleteMany({
                ids: this.selectionEquipData,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'card':
          this.rowId = row.id
          this.checkComp('CARD')
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.formProps.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await employeesHazardCharacteristicsCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
